import { IRenderModel } from '../../types';
import { createFedopsLogger } from './fedops';
import { isSupportChatOrigins } from './isSupportChatOrigins';
import { logger } from './logger';

export const fedopsLogger = createFedopsLogger();

const getInitialData = (): IRenderModel => {
  try {
    const script = document.getElementById('ssr-initial-data')!;
    return JSON.parse(script.textContent ?? '');
  } catch (error) {
    logger.log({
      message: 'fail parse initial data',
      error,
    });
    throw error;
  }
};

class RenderModel {
  private readonly model: IRenderModel;

  constructor() {
    this.model = getInitialData();
  }

  get() {
    return this.model;
  }

  getLocale() {
    return this.model?.locale;
  }

  getUserId() {
    return this.model?.userId;
  }

  getExperiments() {
    return this.model?.experiments;
  }

  getWixBrand() {
    return this.model?.wixBrand;
  }

  getQueryParams() {
    return this.model?.queryParams;
  }

  isInvokedFromHeader() {
    return this.getQueryParams().isInvokedFromHeader === 'true';
  }

  isWixStudio() {
    return this.getQueryParams().brand === 'WixStudio';
  }

  provideRuntimeDataFromSDK() {
    return this.getQueryParams().provideRuntimeDataFromSDK === 'true';
  }

  isFullWidth() {
    return this.model?.isFullWidth ?? this.getQueryParams().fullWidth === 'true';
  }

  isLandingPage(): boolean {
    const originQuery = this.getQueryParams().origin;
    return isSupportChatOrigins(originQuery) && originQuery === 'Landing';
  }

  isWixHeaderDisabled(): boolean {
    return this.getQueryParams()?.referral === 'hoppbywix';
  }

  getWidgetSessionId() {
    return this.model?.widgetSessionId;
  }

  isWidget(): boolean {
    return this.model?.isWidget;
  }

  isChatbotDisabled(): boolean {
    return !!this.model?.isChatbotDisabled;
  }
}

export const renderModel = new RenderModel();
